"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
let MenuButtonComponent = class MenuButtonComponent {
    /**
     * constructor.
     * @param {Router} _router This is the router, it will be used to pass it to the MenuProvider, because only components get the
     * router injected.
    */
    constructor(_router) {
        this._router = _router;
        this._isSelected = false;
        this.onSelected = new core_1.EventEmitter();
    }
    get isSelected() {
        return this.menuItem.isSelected && !this.menuItem.isDisabled;
    }
    get isDisabled() {
        return this.menuItem.isDisabled;
    }
    get text() {
        return this.menuItem.text;
    }
    get isRoot() {
        return this.menuItem.parent == null;
    }
    /**
     * This method will be called when the component is initializing
     * @method ngOnInit
     */
    ngOnInit() {
        if (this._subscription == null && this.menuItem.provider != null) {
            this._subscription = this.menuItem.provider.selectionChangedNotifier.subscribe(entry => {
                if (entry == this.menuItem)
                    this.onSelect();
            });
        }
        if (this.menuItem != null && this.menuItem.isSelected) {
            this.onSelect();
        }
    }
    /**
     * This method will be called when the component was destroyed
     * @method ngOnDestroy
     */
    ngOnDestroy() {
        if (this._subscription != null) {
            this._subscription.unsubscribe();
            this._subscription = null;
        }
    }
    /**
     * This method will be called if anybody clicks on the button.
     * If the menuItem isn't diabled, the selectAction will be called, and if the result is true, the selction change will
     * be emitted to the line.
     */
    onSelect() {
        if (!this.menuItem.isDisabled) {
            //Call the select action and then emit the item id to the parent
            if (this.menuItem.selectAction()) {
                this.onSelected.emit(this.menuItem);
            }
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], MenuButtonComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], MenuButtonComponent.prototype, "menuItem", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], MenuButtonComponent.prototype, "onSelected", void 0);
MenuButtonComponent = __decorate([
    core_1.Component({
        selector: 'menu-button',
        templateUrl: './@inax/buttonMenuUi/src/menuButton/menuButton.component.html',
        styleUrls: ['./@inax/buttonMenuUi/src/menuButton/menuButton.component.css']
    }),
    __metadata("design:paramtypes", [router_1.Router])
], MenuButtonComponent);
exports.MenuButtonComponent = MenuButtonComponent;
